module.exports = __webpack_public_path__ + "static/media/blue-loader.8a25aef4.svg";